import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h3>This is inventory</h3>
        </div>
    );
};

export default Inventory;